import type { Dictionary } from '../i18n/dictionary';
import { toast } from '../lib/toast';
import type { Story } from '../lib/story';

const sample: Dictionary<{
  success: string;
  error: string;
  withAction: string;
  saved: string;
  failed: string;
  open: string;
}> = {
  pl: {
    success: 'Sukces',
    error: 'Błąd',
    withAction: 'Sukces z linkiem',
    saved: 'Portfel zapisany.',
    failed: 'Nie udało się zapisać portfela.',
    open: 'Otwórz',
  },
  en: {
    success: 'Success',
    error: 'Error',
    withAction: 'Success with a link',
    saved: 'Wallet saved.',
    failed: 'Could not save the wallet.',
    open: 'Open',
  },
};

export default {
  kind: 'component',
  title: { pl: 'Toasty', en: 'Toaster' },
  description: {
    pl: 'Jedyne miejsce, w którym pokazują się wyniki żądań. Zamontowany raz w `main.tsx`; ekrany wołają `toast.success` / `toast.error` z `lib/toast.ts`, a błędy zapytań trafiają tu same. Te przyciski wołają prawdziwy `Toaster` — drugi nigdy nie powstaje.',
    en: 'The one place API results are shown. Mounted once in `main.tsx`; screens call `toast.success` / `toast.error` from `lib/toast.ts`, and failed queries land here on their own. These buttons drive the real `Toaster` — a second one is never mounted.',
  },
  variants: [
    {
      name: { pl: 'Rodzaje', en: 'Kinds' },
      render: (locale) => {
        const t = sample[locale];
        return (
          <div className="form-actions">
            <button
              type="button"
              className="btn-ghost"
              onClick={() => toast.error(t.failed)}
            >
              {t.error}
            </button>
            <button
              type="button"
              className="btn-ghost"
              onClick={() =>
                toast.success(t.saved, {
                  action: { label: t.open, to: '/library/toaster' },
                })
              }
            >
              {t.withAction}
            </button>
            <button
              type="button"
              className="btn-primary"
              onClick={() => toast.success(t.saved)}
            >
              {t.success}
            </button>
          </div>
        );
      },
    },
  ],
} satisfies Story;
